__turbopack_context__.v({
  "activeIcon": "STRadioGroup-module__JSaKWG__activeIcon",
  "activeOption": "STRadioGroup-module__JSaKWG__activeOption",
  "errorText": "STRadioGroup-module__JSaKWG__errorText",
  "hiddenInput": "STRadioGroup-module__JSaKWG__hiddenInput",
  "iconWrapper": "STRadioGroup-module__JSaKWG__iconWrapper",
  "label": "STRadioGroup-module__JSaKWG__label",
  "optionLabel": "STRadioGroup-module__JSaKWG__optionLabel",
  "optionText": "STRadioGroup-module__JSaKWG__optionText",
  "optionsWrapper": "STRadioGroup-module__JSaKWG__optionsWrapper",
});
